import React, {useEffect} from 'react';
import NewHomePage from './components/pages/NewHomePage';

function App() {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';

    useEffect(() => {
        if (path === '/new') {
            window.history.replaceState({}, '', '/');
        }
    }, [path]);

    return <NewHomePage/>;
}

export default App;
